import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import Attribute from './components/Attribute';

const PDPSellingAttributesUI = ({
  attributes,
  loading = false,
  productType,
}) => {
  if (loading) {
    return (
      <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0] max-[1023px]:mt-12">
        <div className="text-xl font-bold mt-[5px] mx-0 mb-2.5">
          <Placeholder
            type="rect"
            loading
            style={{ height: '28px', width: '91px' }}
          />
        </div>

        <div>
          {[1, 2, 3].map(index => (
            <div
              className="flex items-center justify-start mx-0 my-[5px]"
              key={`${index}`}
            >
              <Placeholder
                type="rect"
                loading
                style={{ height: '42px', width: '42px' }}
              />

              <Placeholder
                type="rect"
                loading
                style={{ height: '42px', marginRight: '0', maxWidth: '500px' }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0] max-[1023px]:mt-12">
      <h2 className="text-xl font-bold mt-[5px] mx-0 mb-2.5">Features</h2>
      <div>
        {attributes.map(attribute => (
          <Attribute
            key={attribute}
            attribute={attribute}
            productType={productType}
          />
        ))}
      </div>
    </div>
  );
};

PDPSellingAttributesUI.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
  productType: PropTypes.string,
};

export default PDPSellingAttributesUI;
